import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {Observable, from} from 'rxjs';
import {AuthService} from './auth.service';
import { CommonRequestService } from '../shared/services/common-request.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private router: Router,
        public CRS : CommonRequestService,
    ) {}
    canActivate() {
        if (localStorage.getItem('researLoggedIn') || localStorage.getItem('verifyMobile')) { 
            const profileId = this.CRS.decryptService("profileId", false);
            if(profileId == 44){
                this.router.navigate(['research-audit']);
                return false;
            }
            return true;
        }
        else{
            this.router.navigate(['login']);
            return false;
        }
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuditGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private router: Router,
        public CRS : CommonRequestService,
    ) {}

    canActivate() {
        if (localStorage.getItem('researLoggedIn') || localStorage.getItem('verifyMobile')) {
            const profileId = this.CRS.decryptService("profileId", false);
            if(profileId != 44){
                this.router.navigate(['research']);
                return false;
            }
            return true;
        }
        else{
            this.router.navigate(['login']);
            return false;
        }
    }
}
